module.exports = __webpack_public_path__ + "static/media/logo-preto-branco.3e53411c.png";